import React, {useEffect, useState} from "react";
import { Column } from "@amzn/meridian";
import { useAppDispatch } from "src/store/store";
import BarcodeFrame from "../../barcodeScanner/BarcodeFrame";
import { setShownHumanText } from "src/store/workflowSlice";
import StepTransitionSheet from "./StepTransitionSheet";
import "./detectObjectStep.scss";

interface ReadBarcodeStepProps {
  humanText: string;
  onComplete: () => void;
  /** Ends the open-ended container loop and moves on to review. */
  onFinish?: () => void;
}

const ReadBarcodeStep: React.FC<ReadBarcodeStepProps> = ({
  humanText,
  onComplete,
  onFinish,
}) => {
  const dispatch = useAppDispatch();
  const [stepComplete, setStepComplete] = useState(false);

  useEffect(() => {
      dispatch(setShownHumanText(humanText));
  }, []);

  return (
    <Column height="100vh" className="detect-object-step pwa-fullscreen-viewport">
      <BarcodeFrame
        onBarcodeConfirmed={() => setStepComplete(true)}
        onFinish={onFinish}
      />
      { stepComplete && <StepTransitionSheet
        headerMessage="Barcode Scanned."
        message="Get ready to focus container."
        onClose={onComplete}
      />}
    </Column>
  );
};

export default ReadBarcodeStep;
